import {
  ButtonTypes,
  CommonContent,
  Content,
  ContentType,
} from "../types/Types";
import GenericContent from "./../services/GenericContent";
import ContentTypes from "./../services/Content";

const toPrivacyPolicyContent = (
  content: Content[],
  commonContent: CommonContent[]
) => {
  const privacyContent = ContentTypes.filterByContentType(
    content,
    ContentType.TERMS_AND_CONDITIONS
  );
  const cancel = GenericContent.getButtonName(
    commonContent,
    ButtonTypes.CANCEL
  );
  const accept = GenericContent.getButtonName(
    commonContent,
    ButtonTypes.ACCEPT
  );

  return {
    body: privacyContent[0]?.body,
    title: privacyContent[0]?.title,
    cancel,
    accept,
  };
};

const toGameInstructionsPolicyContent = (
  content: Content[],
  commonContent: CommonContent[]
) => {
  const privacyContent = ContentTypes.filterByContentType(
    content,
    ContentType.GAME_INSTRUCTIONS
  );
  const cancel = ""
  const accept = GenericContent.getButtonName(
    commonContent,
    ButtonTypes.ACCEPT
  );

  return {
    body: privacyContent[0]?.body,
    title: privacyContent[0]?.title,
    cancel,
    accept,
  };
};

const replacePlaceholder = (
  text: string,
  placeholder: string,
  replacement: string
): string => {
  const regex = new RegExp(`${placeholder}`, "g");
  return text.replace(regex, replacement);
};

export default {
  toPrivacyPolicyContent,
  toGameInstructionsPolicyContent,
  replacePlaceholder
};
